export enum RoomConnectionState {
  Disconnected,
  Connecting,
  Connected,
}
